import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store/index'
import VueScroller from 'vue-scroller'
import VueLazyload from 'vue-lazyload'
import {
    Picker,
    Popup,
    Switch,
    MessageBox,
    CellSwipe,
    TabContainer,
    TabContainerItem,
    Button,
    Toast,
    InfiniteScroll,
    IndexList,
    IndexSection,
    Field,
    Loadmore,
    DatetimePicker,
    Progress
} from 'mint-ui'
import 'mint-ui/lib/style.css'
import 'lib-flexible/flexible.js'
import '@/api/axios2.js'
import './assets/style/common.css'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import LoadMore from 'vue-loadmore-simple'
import filters from './filters'
import md from '@/utils/middlewares'
import Exposure from '@/utils/exposure'
import Click from '@/utils/click'
import {
    Tab,
    Tabs,
    Sticky,
    Step,
    Steps,
    Area,
    Icon,
    CountDown,
    RadioGroup,
    Radio,
    Swipe,
    SwipeItem,
    List,
    Overlay,
    PullRefresh,
    Search,
    Picker as vPicker,
    Field as vField,
    Button as vButton,
    Toast as vToast,
    Popup as vPopup,
    DatetimePicker as vDatetimePicker,
    Switch as vSwitch,
    Progress as vProgress,
    SwipeCell,
    Checkbox,
    CheckboxGroup,
    Cell,
    CellGroup,
    SwitchCell,
    Dialog,
    Stepper,
    IndexBar,
    IndexAnchor,
    NavBar,
    NoticeBar,
    Grid,
    GridItem,
    PasswordInput,
    NumberKeyboard,
    Uploader,
    Popover,
    ImagePreview
} from 'vant'
import VSwitcher from 'v-switcher'
import 'v-switcher/dist/v-switcher.css'
import ios from './utils/headHeight'
import { mapMutations, mapState, mapActions } from 'vuex'

Vue.use(md)

Vue.use(preview, {
    fullscreenEl: false // 关闭全屏按钮
})

Vue.config.productionTip = false

Vue.use(LoadMore)
Vue.use(VueScroller)
Vue.use(InfiniteScroll)
Vue.use(VueLazyload, {
    preLoad: 2
})
Vue.use(Tab).use(Tabs)
Vue.use(Step).use(Steps)
Vue.use(Sticky)
Vue.use(Area)
Vue.use(vDatetimePicker)
Vue.use(Icon)
Vue.use(CountDown)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(ios)
Vue.use(List)
Vue.use(PullRefresh)
Vue.use(Search)
Vue.use(vField)
Vue.use(vPicker)
Vue.use(vButton)
Vue.use(vToast)
Vue.use(vPopup)
Vue.use(SwipeCell)
Vue.use(SwitchCell)
Vue.use(Cell).use(CellGroup)
Vue.use(Dialog)
Vue.use(vSwitch)
Vue.use(vProgress)
Vue.use(Stepper)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(IndexBar)
Vue.use(IndexAnchor)
Vue.use(NavBar)
Vue.use(NoticeBar)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(PasswordInput)
Vue.use(NumberKeyboard)
Vue.use(Uploader)
Vue.use(Popover)
Vue.use(ImagePreview)

Vue.use(Overlay)
Vue.component(Picker.name, Picker)
Vue.component(Popup.name, Popup)
Vue.component(Switch.name, Switch)
Vue.component(MessageBox.name, MessageBox)
Vue.component(Swipe.name, Swipe)
Vue.component(SwipeItem.name, SwipeItem)
Vue.component(CellSwipe.name, CellSwipe)
Vue.component(TabContainer.name, TabContainer)
Vue.component(TabContainerItem.name, TabContainerItem)
Vue.component(Button.name, Button)
Vue.component(Toast.name, Toast)
Vue.component(IndexList.name, IndexList)
Vue.component(IndexSection.name, IndexSection)
Vue.component(Field.name, Field)
Vue.component(Loadmore.name, Loadmore)
Vue.component(DatetimePicker.name, DatetimePicker)
Vue.component(Progress.name, Progress)
Vue.component(VSwitcher.name, VSwitcher)

// 过滤器
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})
const exp = new Exposure()
const cli = new Click()

Vue.directive('track', {
    bind (el, binding) {
        const { arg } = binding
        arg.split('|').forEach(item => {
            // 点击
            if (item === 'click') {
                cli.add({ el })
            } else if (item === 'exposure') {
                exp.add({ el })
            }
        })
    }
})

Vue.mixin({
    computed: {
        ...mapState({
            pageEnterTime: state => state.b2b.pageEnterTime
        })
    },
    methods: {
        batchTracking (params) {
            const pageTracking = localStorage.getItem('pageTracking')
            if (!pageTracking) {
                localStorage.setItem('pageTracking', JSON.stringify({ track_data_array: [params] }))
            } else {
                let trackingArr = JSON.parse(pageTracking).track_data_array
                if (trackingArr.length >= 4) {
                    this.setBuried({
                        track_data_array: trackingArr
                    })
                    localStorage.setItem('pageTracking', JSON.stringify({ track_data_array: [params] }))
                } else {
                    trackingArr.push(params)
                    localStorage.setItem('pageTracking', JSON.stringify({ track_data_array: trackingArr }))
                }
            }
        },
        ...mapMutations({
            setPageEnterTime: 'PAGE_ENTER_TIME'
        }),
        ...mapActions(['setBuried'])
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.batchTracking({
                event: 998, // 目前没有小b页面的埋点，暂时使用了小b事件埋点做埋点，临时增加event=998作为标志
                buryName: '页面进入事件埋点',
                pageName: to.name,
                pageTitle: to.meta ? to.meta.title : '',
                pagePath: to.fullPath,
                fromName: from.name,
                fromTitle: from.meta ? from.meta.title : '',
                fromPath: from.fullPath
            })
            vm.setPageEnterTime(new Date().getTime())
        })
    },
    beforeRouteLeave (to, from, next) {
        const timeInterval = new Date().getTime() - this.pageEnterTime
        let params = {
            event: 999, // 目前没有小b页面的埋点，暂时使用了小b事件埋点做埋点，临时增加event=999作为标志
            timeInterval: timeInterval,
            buryName: '页面离开事件埋点',
            pageName: from.name,
            pageTitle: from.meta ? from.meta.title : '',
            pagePath: from.fullPath,
            toName: to.name,
            toTitle: to.meta ? to.meta.title : '',
            toPath: to.fullPath,
            pageEnterTime: this.pageEnterTime
        }
        if (this.goods) {
            params.goodsName = this.goods.spuName || this.goods.skuName
            params.goodsCode = this.goods.spuCode || this.goods.skuCode
            params.spikeId = this.spikeId || ''
        }
        // 普通商品详情
        if (this.goodData) {
            params.goodsName = this.goodData.spuName || this.goodData.skuName
            params.goodsCode = this.goodData.spuCode || this.goodData.skuCode
            params.spikeId = this.spikeId || ''
        }
        this.batchTracking(params)
        // this.setPageEnterTime(null)
        next()
    }
})
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
